import React from 'react';
import styled, { css } from 'styled-components';
import BannerNotification from './components/BannerNotification';

import Footer from './components/Footer';

const headerHeight = 74;
const menuOpenedWidth = '250px';
const menuClosedWidth = '73px';

const Wrapper = styled.div`
  /* display: flex;
  position: relative;
  margin-top: ${headerHeight}px;
  height: 100%;
  flex: 1;
  min-height: calc(100vh - ${headerHeight}px); */
  /* box-sizing: border-box;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-end; */
  /* background-color: #f2f2f2;
  height: calc(100% - 74px);
    margin-top: 74px; */
    /* height: calc(100% - 133px); */
  /* ${({ subtractWidth }) => css`
    width: calc(100% - ${subtractWidth});
  `} */

    background-color: #f2f2f2;
    margin-top: 74px;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    /* width: calc(100% - 251px); */

`;

const Container = styled.div`
  height: 100%;
  width: 100%;
  flex: 1;
`;

class Content extends React.Component {
  shouldComponentUpdate(nextProps) {
    if (nextProps.children !== this.props.children || nextProps !== this.props)
      return true;
    return false;
  }

  render() {
    const { menuOpened, currentDealer } = this.props;
    const subtractWidth = menuOpened ? menuOpenedWidth : menuClosedWidth;
    return (
      <Wrapper currentDealer={currentDealer} subtractWidth={subtractWidth}>
        <BannerNotification />

        <Container>{this.props.children}</Container>

        <Footer />
      </Wrapper>
    );
  }
}

export default Content;
